'use client';

import { useCallback, useState } from 'react';
export function useContentFormatter() {
  const [isFormatting, setIsFormatting] = useState<boolean>(false);
  const format = useCallback(async (content: string) => {
    setIsFormatting(true);
    try {
      const res = await fetch('/api/claude-format', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          content
        })
      });
      const data = (await res.json()) as {
        formatted: string;
      };
      if (!res.ok || !data.formatted) {
        console.error('Claude formatting failed', res.statusText);
        return null;
      }
      return data.formatted;
    } catch (error) {
      console.error('Unexpected error while formatting:', error);
      return null;
    } finally {
      setIsFormatting(false);
    }
  }, []);
  return {
    format,
    isFormatting
  };
}